import { Injectable, computed, signal } from '@angular/core'
import { UserProfile } from '@shared/models/user/user.models'

@Injectable({ providedIn: 'root' })
export class ProfileStore {
  // Holds the current user's profile
  private readonly _profile = signal<UserProfile | null>(null)
  // Loading and error flags for profile fetch operations
  private readonly _loading = signal<boolean>(false)
  private readonly _error = signal<string | null>(null)

  // Public readonly signals for consumption by components/services
  readonly profile = this._profile.asReadonly()
  readonly isLoading = this._loading.asReadonly()
  readonly error = this._error.asReadonly()
  // Derived full name for display
  readonly fullName = computed(() => {
    const p = this._profile()
    return p ? `${p.firstName ? p.firstName.charAt(0).toUpperCase() + p.firstName.slice(1).toLowerCase() : ''} ${p.lastName?.toUpperCase()}`.trim() : ''
  })
  readonly civility = computed(() => {
    const p = this._profile()
    return p ? `${p.gender}`: ''
  })
  readonly profession = computed(() => {
    const p = this._profile()
    return p ? `${p.profession}`: ''
  })
  readonly succursale = computed(() => {
    const p = this._profile()
    return p ? `${p.succursale}`: ''
  })

  private readonly _avatar = signal<string>(localStorage.getItem('user_avatar') ?? '')
  readonly avatar = this._avatar.asReadonly()

  // Mutators
  setProfile(profile: UserProfile | null) { this._profile.set(profile) }
  setAvatar(url: string) {
    this._avatar.set(url)
    localStorage.setItem('user_avatar', url)
  }
  updateSuccursale(succursale: string) {
    const p = this._profile()
    if (p) this._profile.set({ ...p, succursale })
  }
  setLoading(v: boolean) { this._loading.set(v) }
  setError(msg: string | null) { this._error.set(msg) }
}


